import { render } from "./TheCall.vue?vue&type=template&id=7803f192"
const script = {}

import "./TheCall.vue?vue&type=style&index=0&id=7803f192&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__